import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";

interface SearchPatientInputProps {
	setSearchValue: (inputValue: string) => void;
	label?: string;
}

export const SearchPatientInput = React.memo(
	({
		label = "Search by Surname, First name",
		setSearchValue
	}: SearchPatientInputProps) => {
		const [inputValue, setInputValue] = useState("");

		useEffect(() => {
			const timer = setTimeout(() => {
				setSearchValue(inputValue);
			}, 1000);

			return () => {
				clearTimeout(timer);
			};
		}, [inputValue, setSearchValue]);

		return (
			<>
				<TextField
					id="patient-search"
					label={label}
					type="search"
					fullWidth
					value={inputValue}
					onChange={(e) => setInputValue(e.target.value)}
					slotProps={{
						input: {
							startAdornment: (
								<InputAdornment position="start">
									<img
										src="images/svg/search.svg"
										height="24px"
										width="24px"
										alt="search patient"
									/>
								</InputAdornment>
							)
						}
					}}
				/>
			</>
		);
	}
);
